import { motion } from 'framer-motion';
import { FaLinkedinIn, FaTwitter, FaInstagram } from 'react-icons/fa';
import { HiMail } from 'react-icons/hi';

const FooterV2 = () => {
  const currentYear = new Date().getFullYear();

  const socialLinks = [
    { Icon: FaLinkedinIn, href: '#', label: 'LinkedIn', color: '#5B8FB9' },
    { Icon: FaTwitter, href: '#', label: 'Twitter', color: '#7CB98F' },
    { Icon: FaInstagram, href: '#', label: 'Instagram', color: '#D4A5B5' },
    { Icon: HiMail, href: 'mailto:hello@susana.com', label: 'Email', color: '#5B8FB9' },
  ];

  const footerLinks = [
    { name: 'Privacy Policy', href: '#' },
    { name: 'Terms of Service', href: '#' },
    { name: 'Imprint', href: '#' },
  ];

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer
      data-testid="footer-v2"
      className="bg-white border-t border-gray-100 py-16 md:py-20 relative overflow-hidden"
    >
      {/* Decorative gradient blobs */}
      <div className="absolute bottom-0 left-0 w-64 h-64 bg-gradient-to-tr from-[#5B8FB9]/5 to-transparent rounded-full -translate-x-1/2 translate-y-1/2" />
      <div className="absolute top-0 right-0 w-48 h-48 bg-gradient-to-bl from-[#D4A5B5]/5 to-transparent rounded-full translate-x-1/2 -translate-y-1/2" />

      <div className="max-w-7xl mx-auto px-6 md:px-12 relative">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 mb-12">
          {/* Left - Big CTA */}
          <div>
            <h3
              className="text-4xl sm:text-5xl font-light tracking-tight bg-gradient-to-r from-[#5B8FB9] via-[#7CB98F] to-[#D4A5B5] bg-clip-text text-transparent mb-6"
              style={{ fontFamily: "'Cormorant Garamond', serif" }}
              data-testid="footer-headline-v2"
            >
              Let's Talk
            </h3>
            <p className="text-lg text-gray-600 font-light mb-8">
              Ready to transform your leadership approach?
            </p>
            <motion.a
              whileHover={{ scale: 1.02 }}
              href="mailto:hello@susana.com"
              className="inline-flex items-center gap-2 text-[#5B8FB9] text-lg font-medium hover:text-[#7CB98F] transition-colors"
              data-testid="footer-email-v2"
            >
              hello@susana.com
            </motion.a>
          </div>

          {/* Right - Navigation & Social */}
          <div className="md:text-right">
            {/* Logo */}
            <motion.button
              whileHover={{ scale: 1.05 }}
              onClick={scrollToTop}
              className="text-2xl font-semibold tracking-wide bg-gradient-to-r from-[#5B8FB9] via-[#7CB98F] to-[#D4A5B5] bg-clip-text text-transparent mb-8 inline-block"
              style={{ fontFamily: "'Cormorant Garamond', serif" }}
              data-testid="footer-logo-v2"
            >
              SUSANA
            </motion.button>

            {/* Social Links */}
            <div className="flex gap-3 md:justify-end mb-8">
              {socialLinks.map(({ Icon, href, label, color }, index) => (
                <motion.a
                  key={index}
                  whileHover={{ scale: 1.1, y: -2 }}
                  href={href}
                  aria-label={label}
                  className="w-10 h-10 rounded-full flex items-center justify-center transition-all duration-300"
                  style={{ 
                    background: `${color}15`,
                    color: color 
                  }}
                  data-testid={`footer-social-v2-${label.toLowerCase()}`}
                >
                  <Icon size={18} />
                </motion.a>
              ))}
            </div>

            {/* Footer Links */}
            <div className="flex flex-wrap gap-6 md:justify-end">
              {footerLinks.map((link, index) => (
                <a
                  key={index}
                  href={link.href}
                  className="text-sm text-gray-500 hover:text-[#5B8FB9] transition-colors"
                  data-testid={`footer-link-v2-${link.name.toLowerCase().replace(/\s/g, '-')}`}
                >
                  {link.name}
                </a>
              ))}
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-gray-100">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-gray-500" data-testid="footer-copyright-v2">
              © {currentYear} Susana. All rights reserved.
            </p>
            <p className="text-sm bg-gradient-to-r from-[#5B8FB9] to-[#7CB98F] bg-clip-text text-transparent font-medium">
              Leadership & Workplace Well-being Advisor
            </p>
          </div>
          <p className="text-center text-xs text-gray-400 mt-6">
            Made with Victory Interactive Inc
          </p>
        </div>
      </div>
    </footer>
  );
};

export default FooterV2;
